import $ from 'jquery';
import { AJAX_URL } from './config';

$(document).ready(() => {
  $('.loading').addClass('is-loading');
  $('#cards_1').insertBefore('#beef-tv-series');

  setTimeout(() => {
    $('.loading-container').hide();
    $('.page-content').fadeTo('slow', 1);
  }, 300);
});
